import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useJwt } from "react-jwt"
import { CreateProfile, GetAllModuleWithoutPage, GetModuleMode } from '../apiconfig/authService';

function AddProfile(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const setMediaTableViewMessage = props.setMessage;

  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState('');

  const [profileName, setProfileName] = useState('');
  const [profileDescription, setProfileDescription] = useState('');
  const [modulesData, setModulesData] = useState([]);
  const [moduleModesData, setModuleModesData] = useState([]);
  const [accessibleModules, setAccessibleModules] = useState([]);

  console.log(accessibleModules);

  const handleProfileNameChange = (e) => {
    setProfileName(e.target.value);
  };

  const handleProfileDescriptionChange = (e) => {
    setProfileDescription(e.target.value);
  };

  const validateInput = () => {
    if (profileName === '')
      throw new Error('Profile Name is required.');
  };


  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;

    try {
      response = await CreateProfile({
        profilename: profileName,
        profiledescription: profileDescription,
        accessiblemodules: accessibleModules,
      }, localStorage.getItem('accessToken'));

      if (response.status === 201) {
        setMediaTableViewMessage(response.data.message);
        navigate("/media");
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
    }
  };

  useEffect(() => {
    (
      async () => {
        try {
          const modulesResponse = await GetAllModuleWithoutPage(localStorage.getItem('accessToken'));
          setModulesData(modulesResponse.data);
          const moduleModesResponse = await GetModuleMode(localStorage.getItem('accessToken'));
          setModuleModesData(moduleModesResponse.data);

          setAccessibleModules(
            modulesData.map(item => {
              return {
                moduleid: item.moduleid,
                accessibleviews: moduleModesData.map(item => item.modulemodeid),
              };
            })
          );

        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, []);

  useEffect(() => {
    if (moduleModesData.length > 0)
      setAccessibleModules(
        modulesData.map(item => {
          return {
            moduleid: item.moduleid,
            accessibleviews: moduleModesData.map(item => item.modulemodeid),
          };
        })
      );
  }, [modulesData, moduleModesData]);


  const moduleCheckboxValue = (moduleid) => {
    const output = (accessibleModules.findIndex(item => {
      return item.moduleid === moduleid;
    }) !== -1) ? true : false;
    return output;
  };

  const tableCheckboxValue = (moduleid, modeid) => {
    return (accessibleModules.findIndex(item => {
      return item.moduleid === moduleid && item.accessibleviews.findIndex(element => element === modeid) !== -1;
    }) !== -1) ? true : false;
  };

  const moduleModeCheckboxValue = (modeid) => {
    return (accessibleModules.findIndex(item => {
      return item.accessibleviews.findIndex(element => element === modeid) !== -1;
    }) !== -1) ? true : false;
  };

  const handleModuleCheckboxClick = (moduleid) => {
    if (moduleCheckboxValue(moduleid)) {
      const indexToDelete = accessibleModules.findIndex(item => item.moduleid === moduleid);
      if (indexToDelete !== -1)
        accessibleModules.splice(indexToDelete, 1);
      setAccessibleModules([...accessibleModules]);
    }
    else {
      const temp = [...accessibleModules, {
        moduleid: moduleid,
        accessibleviews: moduleModesData.map(item => item.modulemodeid),
      }];
      setAccessibleModules(temp);
    }
  };

  const handleTableCheckboxClick = (moduleid, modeid) => {
    if (tableCheckboxValue(moduleid, modeid)) {
      const index = accessibleModules.findIndex(item => {
        return item.moduleid === moduleid && item.accessibleviews.findIndex(element => element === modeid) !== -1;
      });
      const temp = [...accessibleModules];
      temp[index].accessibleviews = temp[index].accessibleviews.filter(items => items !== modeid);
      console.log(temp);
      setAccessibleModules(temp);
    } else {
      const index = accessibleModules.findIndex(item => {
        return item.moduleid === moduleid;
      });
      const temp = [...accessibleModules];
      if (index === -1) {
        temp.push({
          moduleid,
          accessibleviews: [modeid]
        });
      } else {
        temp[index].accessibleviews.push(modeid);
      }
      setAccessibleModules(temp);
    };
  };

  const handleModuleModeCheckboxClick = (modeid) => {
    if (moduleModeCheckboxValue(modeid)) {
      const temp = accessibleModules.map(element => {
        if (element.accessibleviews.includes(modeid)) {
          return {
            moduleid: element.moduleid,
            accessibleviews: element.accessibleviews.filter(item => item !== modeid),
          };
        }
        return {
          moduleid: element.moduleid,
          accessibleviews: element.accessibleviews,
        }
      });
      setAccessibleModules(temp);
    } else {
      const temp = accessibleModules.map(element => {
        if (element.accessibleviews.includes(modeid)) {
          return {
            moduleid: element.moduleid,
            accessibleviews: [...element.accessibleviews],
          };
        }
        return {
          moduleid: element.moduleid,
          accessibleviews: [...element.accessibleviews, modeid],
        }
      });
      setAccessibleModules(temp);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Profile</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/profile" className="btn btn-primary">View All</NavLink>
          </div>
        </div>
        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}
        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <h4 className="text-primary h6 fw-bold">Profile Information</h4>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={profileName} onChange={handleProfileNameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Profile Name</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={profileDescription} onChange={handleProfileDescriptionChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Profile Description</label>
              </div>
            </div>
          </div>
          <h4 className="text-primary h6 fw-bold">Profile Privileges</h4>
          <div className="table-responsive">
            <table className="table table-borderless table-hover">
              <thead>
                <tr>
                  <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col" width="80">
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Modules</span>
                      <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                    </div>
                  </th>
                  {moduleModesData.map(item => {
                    return (
                      <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col" width="80">
                        <div className="tableHeadItems position-relative">
                          <span className="text-ellipsis"><input onChange={() => { handleModuleModeCheckboxClick(item.modulemodeid) }} checked={moduleModeCheckboxValue(item.modulemodeid)} className="form-check-input" type="checkbox" />{item.mode}</span>
                          <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {
                  modulesData.map((module, index) => (
                    <tr key={index}>
                      <td><input className="form-check-input" checked={moduleCheckboxValue(module.moduleid)} onChange={() => { handleModuleCheckboxClick(module.moduleid) }} type="checkbox" />{module.modulename}</td>
                      {
                        moduleModesData.map(moduleMode => {
                          return (<td><input className="form-check-input" onChange={() => { handleTableCheckboxClick(module.moduleid, moduleMode.modulemodeid) }} checked={tableCheckboxValue(module.moduleid, moduleMode.modulemodeid)} type="checkbox" /></td>);
                        })
                      }
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button type="submit" onClick={handleSubmitClick} className="btn btn-primary btn-lg save-btn text-uppercase">Add</button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddProfile;
